import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { RouteType } from "../models/enum";
import { RoleService } from "../shared/services/role.service";
import { GoogleAuthService } from "./google-api.service";

@Injectable({
	providedIn: "root",
})
export class OfficeAdminGuard {
	constructor(
		private router: Router,
		private roleService: RoleService,
		private authService: GoogleAuthService,
	) {}

	async canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<boolean> {
		const isOfficeAdminOrAdmin = (): boolean =>
			this.roleService.isOfficeAdmin || this.roleService.isAdmin;

		if (!navigator.onLine) {
			if (this.authService.hasValidOfflineSession() && isOfficeAdminOrAdmin()) {
				return true;
			}
			this.router.navigate([this.roleService.getDefaultRoute?.() ?? RouteType.DASHBOARD]);
			return false;
		}

		const authenticated = await this.authService.ensureSessionResolved();
		if (authenticated && isOfficeAdminOrAdmin()) {
			return true;
		}

		this.router.navigate([this.roleService.getDefaultRoute?.() ?? RouteType.DASHBOARD]);
		return false;
	}
}
